import { useState, useCallback } from 'react';

export const useAppointmentStatus = ( post, setUiMessage) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const checkAppState = useCallback(
    async (appId, onSuccess) => {
      setIsLoading(true);
      try {
        const response = await post(
          'api/appointment/Appointment/checkAppState',
          {
            appId: appId,
          },
        );

        if (response?.status === 200) {
          if (response.data?.status === 'checkin') {
            setIsDialogOpen(true);
          } else {
            // If not checked in, proceed with the intended action
            onSuccess();
          }
        }
      } catch (err) {
        // Handle error using the provided UI message setter
        if (setUiMessage) {
          setUiMessage('err', err.message);
        } else {
          console.error(err);
        }
      } finally {
        setIsLoading(false);
      }
    },
    [post, setUiMessage],
  );

  const closeDialog = () => setIsDialogOpen(false);

  return {
    isDialogOpen,
    isLoading,
    checkAppState,
    closeDialog,
  };
};
